import React from "react";
import {FourPointStar, CrookedStar} from "../../../assets";

const QuestionCard = ({
  questionText,
  options,
  selectedOptionId,
  onSelect,
  onPrevious,
  onNext,
  showPrevious,
  currentIndex,
  totalQuestions,
}) => {

  // Fungsi untuk mencari bagian teks yang ingin di-bold dan menambah tag <b> di frontend
  const formatText = (text) => {
    // Aturan format: mencari teks tertentu dan membungkusnya dengan <b> 
    // Gantilah bagian yang perlu di-bold
    let formattedText = text;

    // Misalnya, kita ingin membold "Choose the correct" dan "According to the passage"
    const boldPatterns = [
      "Choose the correct sentence",
      "Fill in the blank with the correct verb form",
      "Choose the correct preposition",
      "Choose the correct article",
      "Fill in the blank with the correct form of the adjective",
      "Choose the correct pronoun",
      "Choose the correct form of the verb",
      "Choose the correct word",
      "Fill in the blank with the correct conjunction",
      "Choose the correct form of the adjective",
      "Fill in the blank with the correct article",
      "Choose the word that is most similar in meaning to",
      "Choose the word that best completes the sentence",
      "Choose the word that is most opposite in meaning to",
      "What is the main benefit of online shopping mentioned in the passage?",
      "According to the passage, what is one concern about online shopping?",
      "True or False: The passage suggests that online shopping has no drawbacks",
      "What can be inferred about the future of shopping?",
      "Which of the following is NOT a concern raised in the passage about online shopping?",
    ];

    // Ganti teks yang sesuai dengan tag <b>
    boldPatterns.forEach((pattern) => {
      const regex = new RegExp(`(${pattern})`, "g");
      formattedText = formattedText.replace(regex, "<b>$1</b>");
    });

    return formattedText;
  };

  // Format teks soal
  const formattedQuestionText = formatText(questionText);

  return (
    <div className="w-full max-w-3xl mx-auto relative z-20 font-poppins mt-4 pb-10 overflow-visible">
      {/* Back folder layer */}
      <div
        className="pointer-events-none absolute inset-x-0 top-3 z-0 rounded-[30px] bg-[#FFCE43] shadow-[0_18px_32px_rgba(0,0,0,0.12)]"
        style={{
          height: `520px`,
          bottom: "10px",
          transform: "translateX(28px) translateY(26px) rotate(3deg)",
          transformOrigin: "top right",
        }}
        aria-hidden="true"
      />
      {/* Inactive Static Tab (Result) - Positioned above yellow folder */}
      <div className="absolute isolate px-10 sm:px-14 py-3 font-bold z-[-1] text-[15px] sm:text-[16px] text-[--st-color-program-red] cursor-default"
        style={{
          transform: "translateX(1rem) rotate(3deg)",
          transformOrigin: "top right",
          right: "20px",
          top: "-8px",
        }}
      >
        <div
          className="absolute inset-0 bg-[#FFCE43] z-[-1] border-t border-r border-[#E9BC1D] border-b-0"
          style={{
            transform: "perspective(50px) rotateX(15deg)",
            transformOrigin: "bottom",
            borderRadius: "12px 12px 0 0",
          }}
        />
        <span className="relative z-10 block translate-y-[6px]">Result</span>
      </div>

      {/* Tabs */}
      <div className="flex items-end justify-end pr-4 sm:pr-10 relative z-10 w-full mb-[-1px]" style={{ transform: "translateX(-8rem)" }}>
        {/* Active Tab (Questions) */}
        <div className="relative isolate px-10 sm:px-13 py-3 font-bold z-20 text-[15px] sm:text-[16px] text-white cursor-default">
          <div
            className="absolute inset-0 bg-[--st-color-program-red] z-[-1] shadow-[0_-5px_10px_rgba(0,0,0,0.15)] border-b-0"
            style={{
              transform: "perspective(50px) rotateX(15deg)",
              transformOrigin: "bottom",
              borderRadius: "12px 12px 0 0",
            }}
          />
          <span className="relative z-10 block translate-y-[6px]">Questions</span>
        </div>
        
      </div>

      {/* Main Folder Card */}
      <div className="bg-[--st-color-program-red] rounded-3xl sm:rounded-tr-xl p-6 sm:p-10 shadow-[0_10px_30px_rgba(0,0,0,0.15)] relative z-30 flex flex-col min-h-[400px]">
        {/* Render Question with Bold Text */}
        <h2
          className={`text-white text-lg sm:text-xl mb-8 leading-relaxed relative z-20 ${
            currentIndex < 26 ? "font-normal" : "font-bold"
          }`}
          dangerouslySetInnerHTML={{ __html: formattedQuestionText }}
        />
        {/* Decorative Stars */}
        <img
          src={FourPointStar}
          alt=""
          className="pointer-events-none absolute left-[-26px] top-[15%] z-10 hidden w-[96px] sm:block lg:left-[-58px] lg:w-[116px]"
          loading="lazy"
        />  
        <img
          src={CrookedStar}
          alt=""
          className="pointer-events-none absolute right-[-45px] top-[40%] z-10 hidden w-[126px] sm:block lg:right-[-65px] lg:w-[128px]"
          loading="lazy"
        />

        {/* Options */}
        <div className="space-y-4 flex-grow mb-6 relative z-20">
          {options.map((option) => {
            const isSelected = selectedOptionId === option.id;
            return (
              <button
                key={option.id}
                onClick={() => onSelect(option.id)}
                className={`st-placement-option ${
                  isSelected ? "st-placement-option-selected" : "st-placement-option-unselected"
                }`}
              >
                {option.option_text}
              </button>
            );
          })}
        </div>

        {/* Footer Navigation */}
        <div className="flex justify-between items-center mt-auto pt-6 border-t border-white/20">
          {showPrevious ? (
            <button
              onClick={onPrevious}
              className="st-btn-base bg-gray-300 text-gray-700 px-6 py-2.5 hover:bg-gray-400 shadow-md text-[14px]"
            >
              Back
            </button>
          ) : (
            <div /> // Spacer if no previous button
          )}

          {currentIndex < totalQuestions - 1 ? (
            <button
              onClick={onNext}
              className="st-btn-base bg-[#1A7A3A] text-white px-8 py-2.5 hover:bg-[#163026] shadow-md text-[14px]"
            >
              Lanjut
            </button>
          ) : (
            <button
              onClick={onNext}
              className="st-btn-base bg-[#1A7A3A] text-white px-8 py-2.5 hover:bg-[#163026] shadow-md text-[14px]"
            >
              Selesai
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuestionCard;
